// ─── Registro de documentações da Central de Ajuda ─────────────────────────────
// Para adicionar uma nova documentação: crie um arquivo neste diretório seguindo
// a mesma forma (id, titulo, pathModulo, icone, allowedRoles, descricao,
// passoAPasso, dicas, faq) e importe-o + adicione-o à lista abaixo.
// Nenhuma outra estrutura (rotas, menu, backend) precisa ser alterada.

import modulosOperacionais from "./modulosOperacionais";
import orcamentoDash from "./orcamentoDash";
import painelExecutivo from "./painelExecutivo";
import monitoramentoFinanceiroOperacional from "./monitoramentoFinanceiroOperacional";

export const MODULOS_DOCUMENTACAO = [
  modulosOperacionais,
  orcamentoDash,
  painelExecutivo,
  monitoramentoFinanceiroOperacional,
];

// Busca tanto pelo id de um módulo de topo (ex.: "modulos-operacionais")
// quanto pelo id de um sub-módulo agrupado dentro dele (ex.: "margem-bruta"),
// para manter compatibilidade com links/feedbacks antigos apontando direto
// para o sub-módulo.
export const getModuloDocumentacao = (id) => {
  for (const modulo of MODULOS_DOCUMENTACAO) {
    if (modulo.id === id) return modulo;
    const subModulo = modulo.subModulos?.find((m) => m.id === id);
    if (subModulo) return subModulo;
  }
  return null;
};
